import { money } from "../../utilities/currency";

/** Español (Spanish) */
const es = {
  home: {
    offer: "✨ Oferta especial – ¡Paga 99 kr y obtén 198 kr en crédito de llamadas! ✨",
    signIn: "Iniciar sesión",
    join: "Únete",
    allAdvisors: "Todos los asesores",
    festivalTitle: "Campañas de festival",
    referTitle: "¡Obtén tu primera consulta gratis!",
    referBody:
      "Reserva una llamada gratuita de 15 minutos. Perfecta para encontrar al asesor adecuado: seguro, digital y sin compromisos.",
    blogTitle: "Del blog de Mystic",
    viewAll: "Ver todo",
    subscribeLine: "Recibe nuevas guías y ofertas por correo electrónico.",
    read: "Leer",
    invite: "Reservar consulta gratuita",
    sponsored: "Patrocinado",
    ad: (n) => `Anuncio ${n}`,
    adBlurb: "Anuncia productos, aplicaciones o eventos aquí.",
    learnMore: "Saber más",
    connectNow: "Conectar ahora",
    from: "desde",
    minutes: "min",
    verified: "Verificado",
    categories: [
      "Lectura del amor",
      "Lectura clarividente",
      "Lectura de tarot",
      "Astrología y Horóscopo",
      "Mensajes de ángeles",
      "Guía con oráculos",
      "Interpretación de sueños",
      "Médium espiritual",
    ],
    hero: {
      name: "Los Asesores",
      tag: "Experto en amor",
      blurb:
        "Mi promesa: estoy aquí para ti. Cuando es difícil saber en quién confiar, la presencia auténtica lo es todo.",
      getReading: "Reservar consulta",
    },
    footer: {
      getApp: "Consigue la app para tener claridad estés donde estés.",
      explore: "Explorar",
      special: "Especialidades",
      more: "Más",
      advisors: "Asesores",
      blog: "Nuestro blog",
      applyCode: "Usar código promocional",
      support: "Atención al cliente",
      about: "Sobre nosotros",
      apply: "¿Asesor? Solicita aquí",
      privacy: "Privacidad",
      terms: "Términos",
    },
    wallet: {
      title: "Comprar minutos de llamada",
      intro:
        "Los minutos se guardan en tu monedero Mystic y se pueden usar con cualquier asesor (chat / llamada / vídeo).",
      numLabel: "El número de teléfono desde el que llamas",
      amount: "Elige el importe",
      buy: (amt) => `Comprar ${money(amt)} de crédito`,
      learn: "Más información sobre métodos de pago",
      err: "Introduce un número de teléfono válido",
      otp: (n) => `Código enviado a ${n}. Introdúcelo para confirmar.`,
      enterOtp: "Introduce el código",
      verify: "Confirmar y añadir crédito",
      cancel: "Cancelar",
      success: (amt) => `¡${money(amt)} añadidos a tu monedero!`,
      pm1: "Vipps MobilePay",
      pm2: "Tarjeta (requiere registro con tu número de móvil)",
      nolgin: "No se necesita iniciar sesión para Vipps MobilePay: llama directamente.",
    },
  },

  header: {
    hello: "Hola",
    logout: "Cerrar sesión",
    login: "Iniciar sesión",
  },

  footer: {
    categories: [
      "Dummy 1",
      "Dummy 2",
      "Dummy 3",
      "Dummy 4",
      "Dummy 5",
      "Dummy 6",
      "Dummy 7",
      "Dummy 8",
    ],
    paymentMethods: "Métodos de pago",
    footer: {
      getApp: "Consigue la app para tener claridad estés donde estés.",
      explore: "Explorar",
      special: "Especialidades",
      more: "Más",
      advisors: "Asesores",
      blog: "Nuestro blog",
      applyCode: "Usar código promocional",
      support: "Atención al cliente",
      about: "Sobre nosotros",
      apply: "¿Asesor? Solicita aquí",
      privacy: "Privacidad",
      terms: "Términos",
    },
  },
};

export default es;
